import React, { useState } from 'react';
import classNames from 'classnames';
import AsLinkButton from '../buttons/AsLinkButton/AsLinkButton';

function AdvancedDescription({ buttonTitle, buttonText, text, ...props }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="group__advanced-description">
      <AsLinkButton
        title={buttonTitle}
        className={classNames('advanced-description__link', 'js-form-advanced-description-link', {
          'advanced-description__link--active': isOpen
        })}
        onPress={() => setIsOpen(!isOpen)}
      >
        {buttonText}
      </AsLinkButton>
      <div
        {...props}
        className={classNames('advanced-description__content', 'js-form-advanced-description-content', {
          hidden: !isOpen
        })}
      >
        {text}
      </div>
    </div>
  );
}

export default AdvancedDescription;
